module.exports = __webpack_public_path__ + "assets/media/code.b3c3ab92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/code.svg
// module id = 71
// module chunks = 0